(function () {
  function updateProductSleepUrls(productGrid) {
    if (!productGrid) return;

    const productItems = productGrid.querySelectorAll('.product-item');
    const imageLoadPromises = [];

    productItems.forEach((item) => {
      const productCard = item.querySelector('.product-card');
      if (productCard) productCard.classList.add('product-card-loading');

      const sleepUrl = item.getAttribute('data-product-sleep-url');
      if (sleepUrl && sleepUrl.trim() !== '') {
        const influencerLinks = item.querySelectorAll('.product-card-influencers');
        const featuredImageLinks = item.querySelectorAll('.product-featured-image-link');
        [...influencerLinks, ...featuredImageLinks].forEach((link) => {
          link.setAttribute('href', sleepUrl);
        });

        const swatchDivs = item.querySelectorAll('.product-card-swatch[data-href]');
        swatchDivs.forEach((div) => {
          const dataHref = div.getAttribute('data-href');
          if (dataHref && dataHref.includes('?variant=')) {
            const variantPart = dataHref.substring(dataHref.indexOf('?variant='));
            div.setAttribute('data-href', sleepUrl + variantPart);
          }
        });
      }

      const sleepGalleryImage = item.getAttribute('data-product-sleep-gallery-image');
      if (sleepGalleryImage && sleepGalleryImage.trim() !== '') {
        const productImage = item.querySelector('.product-featured-image');
        if (productImage) {
          const loadPromise = new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
              productImage.src = sleepGalleryImage;
              productImage.srcset = sleepGalleryImage;
              resolve();
            };
            img.onerror = () => resolve();
            img.src = sleepGalleryImage;
          });
          imageLoadPromises.push(loadPromise);
        }

        const pictureElement = item.querySelector('.product-primary-image-container .product-primary-image-picture');
        if (pictureElement) {
          const sources = pictureElement.querySelectorAll('source');
          sources.forEach((source) => source.setAttribute('srcset', sleepGalleryImage));

          const img = pictureElement.querySelector('img.product-primary-image');
          if (img) {
            const loadPromise = new Promise((resolve) => {
              const tempImg = new Image();
              tempImg.onload = () => {
                img.src = sleepGalleryImage;
                img.srcset = sleepGalleryImage;
                if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', sleepGalleryImage);
                resolve();
              };
              tempImg.onerror = () => resolve();
              tempImg.src = sleepGalleryImage;
            });
            imageLoadPromises.push(loadPromise);
          }
        }
      }

      const variantImagesData = item.getAttribute('data-variant-sleep-images');
      const variantImagesHoverData = item.getAttribute('data-variant-sleep-images-hover');

      if (variantImagesData && variantImagesData.trim() !== '') {
        try {
          const variantImages = JSON.parse(variantImagesData);
          const variantImagesHover = variantImagesHoverData ? JSON.parse(variantImagesHoverData) : {};

          const swatchDivs = item.querySelectorAll('.product-card-swatch[data-href]');
          swatchDivs.forEach((div) => {
            const dataHref = div.getAttribute('data-href');
            if (dataHref && dataHref.includes('?variant=')) {
              const variantId = dataHref.split('?variant=')[1].split('&')[0];
              if (variantImages[variantId]) {
                const imageUrl = variantImages[variantId];
                const urlMatch = imageUrl.match(/\/files\/([^?]+)/);
                if (urlMatch) div.setAttribute('data-image-default', `files/${urlMatch[1]}`);
              }
            }
          });

          const secondaryPicture = item.querySelector('.product-secondary-image-container .product-secondary-image-picture');
          if (secondaryPicture && Object.keys(variantImagesHover).length > 0) {
            const firstVariantId = Object.keys(variantImagesHover)[0];
            const hoverImageUrl = variantImagesHover[firstVariantId];
            if (hoverImageUrl) {
              const sources = secondaryPicture.querySelectorAll('source');
              sources.forEach((source) => source.setAttribute('srcset', hoverImageUrl));

              const img = secondaryPicture.querySelector('img');
              if (img) {
                const loadPromise = new Promise((resolve) => {
                  const tempImg = new Image();
                  tempImg.onload = () => {
                    img.src = hoverImageUrl;
                    img.srcset = hoverImageUrl;
                    if (img.hasAttribute('data-srcset')) img.setAttribute('data-srcset', hoverImageUrl);
                    resolve();
                  };
                  tempImg.onerror = () => resolve();
                  tempImg.src = hoverImageUrl;
                });
                imageLoadPromises.push(loadPromise);
              }
            }
          }
        } catch (e) {
          console.error('Error parsing variant sleep images:', e);
        }
      }
    });

    Promise.all(imageLoadPromises).then(() => {
      productItems.forEach((item) => {
        const productCard = item.querySelector('.product-card');
        if (productCard) productCard.classList.remove('product-card-loading');
      });
    });
  }

  function initSection(root) {
    const sectionId = root.dataset.sectionId;
    if (!sectionId) return;

    const form = document.getElementById(`collection-search-form-${sectionId}`);
    const searchInput = document.getElementById(`search-input-${sectionId}`);
    const productGrid = document.getElementById(`product-grid-${sectionId}`);
    const loadMoreBtn = document.getElementById(`load-more-btn-${sectionId}`);
    const loadMoreContainer = document.getElementById(`load-more-container-${sectionId}`);
    const noResults = document.getElementById(`no-results-${sectionId}`);
    const resultsCount = document.getElementById(`results-count-${sectionId}`);
    const totalResults = document.getElementById(`total-results-${sectionId}`);
    const sortContainer = document.getElementById(`sort-container-${sectionId}`);
    const sortSelect = document.getElementById(`sort-select-${sectionId}`);

    const urlParams = new URLSearchParams(window.location.search);
    const searchTerm = urlParams.get('q');

    if (searchInput && searchTerm) searchInput.value = searchTerm;

    if (form) {
      urlParams.forEach((value, key) => {
        if (key !== 'q') {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.appendChild(input);
        }
      });
    }

    if (!productGrid) return;

    const resultsSingular = root.dataset.resultsLabelSingular || 'result';
    const resultsPlural = root.dataset.resultsLabelPlural || 'results';
    const resultsFoundPrefix = root.dataset.resultsFoundPrefix || 'found for';

    const productsPerPage = parseInt(productGrid.dataset.productsPerPage || '12', 10);
    const paginationType = productGrid.dataset.paginationType || 'paginated';
    let currentPage = 1;
    let isSearchActive = false;

    function filterProducts() {
      if (!searchTerm || searchTerm.trim() === '') {
        isSearchActive = false;
        return;
      }

      isSearchActive = true;
      const searchQuery = searchTerm.toLowerCase().trim();
      const productItems = productGrid.querySelectorAll('.product-item');
      let visibleCount = 0;

      productItems.forEach((item) => {
        const title = item.getAttribute('data-product-title') || '';
        const tags = item.getAttribute('data-product-tags') || '';
        const vendor = item.getAttribute('data-product-vendor') || '';
        const type = item.getAttribute('data-product-type') || '';

        const matches = title.includes(searchQuery) || tags.includes(searchQuery) || vendor.includes(searchQuery) || type.includes(searchQuery);
        item.dataset.searchMatch = matches ? 'true' : 'false';
        if (matches) visibleCount++;
      });

      updateProductSleepUrls(productGrid);

      const resultsLabel = visibleCount === 1 ? resultsSingular : resultsPlural;
      if (resultsCount) {
        resultsCount.classList.remove('is-hidden');
        resultsCount.textContent = `${visibleCount} ${resultsLabel} ${resultsFoundPrefix} "${searchTerm}"`;
      }
      if (totalResults) {
        totalResults.classList.remove('is-hidden');
        totalResults.textContent = `${visibleCount} ${resultsLabel}`;
      }
      if (sortContainer) sortContainer.classList.remove('is-hidden');

      if (visibleCount === 0 && noResults) {
        noResults.classList.remove('is-hidden');
        productGrid.classList.add('is-hidden');
      } else if (noResults) {
        noResults.classList.add('is-hidden');
        productGrid.classList.remove('is-hidden');
      }
    }

    function updateProductsVisibility() {
      const productItems = Array.from(productGrid.querySelectorAll('.product-item'));
      const relevantItems = isSearchActive ? productItems.filter((item) => item.dataset.searchMatch === 'true') : productItems;
      const totalProducts = relevantItems.length;
      const itemsToShow = currentPage * productsPerPage;

      productItems.forEach((item) => {
        item.classList.add('is-hidden');
      });
      relevantItems.forEach((item, index) => {
        if (index < itemsToShow) item.classList.remove('is-hidden');
      });

      updateProductSleepUrls(productGrid);

      if (loadMoreContainer) {
        if (paginationType === 'loadmore' && itemsToShow < totalProducts) {
          loadMoreContainer.classList.remove('is-hidden');
        } else {
          loadMoreContainer.classList.add('is-hidden');
        }
      }
    }

    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', () => {
        currentPage++;
        updateProductsVisibility();
      });
    }

    if (paginationType === 'infinite') {
      let isLoading = false;
      window.addEventListener('scroll', () => {
        if (isLoading) return;
        const scrollPosition = window.scrollY + window.innerHeight;
        const pageHeight = document.documentElement.scrollHeight;
        if (scrollPosition >= pageHeight - 200) {
          const productItems = Array.from(productGrid.querySelectorAll('.product-item'));
          const relevantItems = isSearchActive ? productItems.filter((item) => item.dataset.searchMatch === 'true') : productItems;
          const itemsToShow = currentPage * productsPerPage;
          if (itemsToShow < relevantItems.length) {
            isLoading = true;
            currentPage++;
            updateProductsVisibility();
            setTimeout(() => {
              isLoading = false;
            }, 300);
          }
        }
      });
    }

    if (sortSelect) {
      sortSelect.addEventListener('change', function () {
        const sortValue = this.value;
        const productItems = Array.from(productGrid.querySelectorAll('.product-item'));

        if (sortValue === 'price-ascending') {
          productItems.sort((a, b) => parseFloat(a.dataset.productPrice || '0') - parseFloat(b.dataset.productPrice || '0'));
        } else if (sortValue === 'price-descending') {
          productItems.sort((a, b) => parseFloat(b.dataset.productPrice || '0') - parseFloat(a.dataset.productPrice || '0'));
        } else {
          productItems.sort((a, b) => parseInt(a.dataset.productIndex || '0', 10) - parseInt(b.dataset.productIndex || '0', 10));
        }

        productGrid.innerHTML = '';
        productItems.forEach((item) => productGrid.appendChild(item));

        currentPage = 1;
        updateProductsVisibility();
      });
    }

    filterProducts();
    updateProductsVisibility();
    updateProductSleepUrls(productGrid);
  }

  document.querySelectorAll('.sleep-collection-search[data-section-id]').forEach(initSection);
})();
